"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const notification_event_template_mapping_entity_1 = require("../../../../service-lib/src/lib/entities/notification-event-template-mapping.entity");
const notification_event_type_entity_1 = require("../../../../service-lib/src/lib/entities/notification-event-type.entity");
const notification_in_app_entity_1 = require("../../../../service-lib/src/lib/entities/notification-in-app.entity");
const notification_log_entity_1 = require("../../../../service-lib/src/lib/entities/notification-log.entity");
const notification_template_entity_1 = require("../../../../service-lib/src/lib/entities/notification-template.entity");
const notififcation_log_receiver_record_entity_1 = require("../../../../service-lib/src/lib/entities/notififcation-log-receiver-record.entity");
const typeorm_2 = require("typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const constants_1 = require("../../../../service-lib/src/lib/constants");
let NotificationRepository = class NotificationRepository {
    constructor(eventRepo, mappingRepo, templateRepo, logRepo, inAppRepo, logReceiverRepo, lookUpRepo, entityService) {
        this.eventRepo = eventRepo;
        this.mappingRepo = mappingRepo;
        this.templateRepo = templateRepo;
        this.logRepo = logRepo;
        this.inAppRepo = inAppRepo;
        this.logReceiverRepo = logReceiverRepo;
        this.lookUpRepo = lookUpRepo;
        this.entityService = entityService;
    }
    findEventByName(name) {
        return this.eventRepo.findOne({ where: { name } });
    }
    findInAppNotificationById(id) {
        return this.inAppRepo.findOne({
            where: { id },
        });
    }
    findTemplateMapping(event, channel) {
        return this.mappingRepo.findOne({
            where: { eventType: event, channel },
            relations: ["template"],
        });
    }
    saveLog(log) {
        return this.logRepo.save(log);
    }
    saveUserLogRecord(log) {
        return this.logReceiverRepo.save(log);
    }
    async saveInApp(notification) {
        const status = await this.lookUpRepo.findOne({ where: { lookUpKey: constants_1.NOTIFICATION_STATUS_UNREAD } });
        if (!status) {
            throw new Error("Status for read notifications not found");
        }
        return this.inAppRepo.save(notification.map(n => ({ ...n, statusLid: status.id })));
    }
    async getInAppNotifications(userId, page, limit, status) {
        try {
            const whereCondition = {};
            whereCondition.userId = userId;
            if (status) {
                const statusLid = await this.lookUpRepo.findOne({ where: { lookUpKey: status } });
                if (!statusLid) {
                    throw new Error("Status for unread notifications not found");
                }
                whereCondition.statusLid = statusLid.id;
            }
            const { data } = await this.entityService.fetchEntityList(notification_in_app_entity_1.NotificationInApp, page, limit, [{ field: "status", order: "ASC" }, { field: "id", order: "DESC" }], undefined, whereCondition, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);
            return data;
        }
        catch (error) {
            console.log("Error fetching in-app notifications:", error);
            throw new Error("Error fetching in-app notifications");
        }
    }
    async countUnreadInAppNotifications(userId) {
        const status = await this.lookUpRepo.findOne({ where: { lookUpKey: constants_1.NOTIFICATION_STATUS_UNREAD } });
        if (!status) {
            throw new Error("Status for unread notifications not found");
        }
        return this.inAppRepo.count({ where: { statusLid: status.id, userId: userId } });
    }
    async findLatestInAppNotification(status) {
        const statusKey = await this.lookUpRepo.findOne({ where: { lookUpKey: status } });
        if (!statusKey) {
            throw new Error("Status for read notifications not found");
        }
        return this.inAppRepo.findOne({
            where: { statusLid: statusKey.id },
            order: { id: "DESC" }
        });
    }
    async markNotificationRead(notificationId) {
        const status = await this.lookUpRepo.findOne({ where: { lookUpKey: constants_1.NOTIFICATION_STATUS_READ } });
        if (!status) {
            throw new Error("Status for read notifications not found");
        }
        return this.inAppRepo.update({ id: notificationId }, { statusLid: status.id, updatedAt: new Date() });
    }
    async deleteNotification(notificationId) {
        const status = await this.lookUpRepo.findOne({ where: { lookUpKey: constants_1.NOTIFICATION_STATUS_DELETE } });
        if (!status) {
            throw new Error("Status for read notifications not found");
        }
        return this.inAppRepo.update({ id: notificationId }, { statusLid: status.id, deletededAt: new Date() });
    }
};
exports.NotificationRepository = NotificationRepository;
exports.NotificationRepository = NotificationRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(notification_event_type_entity_1.NotificationEventType)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(notification_event_template_mapping_entity_1.NotificationEventTemplateMapping)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(notification_template_entity_1.NotificationTemplate)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(notification_log_entity_1.NotificationLog)),
    tslib_1.__param(4, (0, typeorm_1.InjectRepository)(notification_in_app_entity_1.NotificationInApp)),
    tslib_1.__param(5, (0, typeorm_1.InjectRepository)(notififcation_log_receiver_record_entity_1.NotificationLogReceiverRecord)),
    tslib_1.__param(6, (0, typeorm_1.InjectRepository)(entities_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _e : Object, typeof (_f = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _f : Object, typeof (_g = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _g : Object, typeof (_h = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _h : Object])
], NotificationRepository);
